import React from 'react';
import Divider from '@material-ui/core/Divider';

const BasicProfileFormDivider = ({ style = {} }) => {
    return <Divider style={{ margin: '24px 0 40px', ...style }} />;
};

export default BasicProfileFormDivider;
